import { render, staticRenderFns } from "./dell.vue?vue&type=template&id=af218c00"
import script from "./dell.vue?vue&type=script&lang=js"
export * from "./dell.vue?vue&type=script&lang=js"
import style0 from "./dell.vue?vue&type=style&index=0&id=af218c00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports